import { render } from "./CompaniesFilters.vue?vue&type=template&id=7824e046"
import script from "./CompaniesFilters.vue?vue&type=script&lang=js"
export * from "./CompaniesFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__